/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
author: Ethan Cragun (https://sketchfab.com/EDIIIC)
license: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
source: https://sketchfab.com/3d-models/self-portrait-mk2-015d78950d744890a4b2d4fc506561d5
title: Self Portrait Mk.2
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useFrame } from '@react-three/fiber';

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials } = useGLTF(`${process.env.PUBLIC_URL}/model.gltf`)
  useFrame(() => {
    if (group.current) {
      group.current.rotation.y += 0.01
    }
  })
  return (
    <group ref={group} {...props} dispose={null}>
      <group rotation={[-Math.PI / 2, 0, 0]} scale={0.5}>
        <group rotation={[Math.PI / 2, 0, 0]}>
          <mesh geometry={nodes.Hair_Hair1_0.geometry} material={materials.Hair1} />
          <mesh geometry={nodes.soul_patch_Hair1_0.geometry} material={materials.Hair1} />
          <mesh geometry={nodes.Moustach_Hair1_0.geometry} material={materials.Hair1} />
          <mesh geometry={nodes.Chin_Hair1_0.geometry} material={materials.Hair1} />
          <mesh geometry={nodes.Eyelashes_R_Hair1_0.geometry} material={materials.Hair1} />
          <mesh geometry={nodes.Eyelashes_L_Hair1_0.geometry} material={materials.Hair1} />
          <mesh geometry={nodes.Eye_Brow_R_Hair1_0.geometry} material={materials.Hair1} />
          <mesh geometry={nodes.Eye_Brow_L_Hair1_0.geometry} material={materials.Hair1} />
          <mesh geometry={nodes.Head_High_Skin_0.geometry} material={materials.Skin} />
          <mesh geometry={nodes.R_Eye_Eye_0.geometry} material={materials.material} />
          <mesh geometry={nodes.L_Eye_Eye_0.geometry} material={materials.material} />
          <mesh geometry={nodes.Shirt_Shirt1_0.geometry} material={materials.Shirt1} />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload(`${process.env.PUBLIC_URL}/model.gltf`)
